// extracted by css-extract-rspack-plugin
export default {"root":"SettingsPageLayout_root__G3c_0"};